function parts(date: Date, timezone: string): Record<string, number> {
  const fmt = new Intl.DateTimeFormat('en-GB', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  return Object.fromEntries(fmt.formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
}

export function zonedInputValues(instant: string, timezone: string): { date: string; time: string } {
  const date = new Date(instant);
  if (!Number.isFinite(date.getTime())) throw new Error('Data întâlnirii este invalidă.');
  const p = parts(date, timezone), two = (n: number) => String(n).padStart(2, '0');
  return { date: `${p.year}-${two(p.month)}-${two(p.day)}`, time: `${two(p.hour)}:${two(p.minute)}` };
}

/** Reject ambiguous and nonexistent daylight-saving wall times. */
export function zonedTimeToIso(date: string, time: string, timezone: string): string {
  const dm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date), tm = /^(\d{2}):(\d{2})$/.exec(time);
  if (!dm || !tm) throw new Error('Introduceți o dată și o oră valide.');
  const [year, month, day, hour, minute] = [+dm[1], +dm[2], +dm[3], +tm[1], +tm[2]];
  const target = Date.UTC(year, month - 1, day, hour, minute);
  const check = new Date(target);
  if (hour > 23 || minute > 59 || check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) throw new Error('Data sau ora este invalidă.');
  const offsets = new Set<number>();
  for (let h = -36; h <= 36; h += 6) {
    const sample = target + h * 3600000, p = parts(new Date(sample), timezone);
    offsets.add(Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - sample);
  }
  const matches = [...offsets].map(offset => target - offset).filter(ms => {
    const p = parts(new Date(ms), timezone);
    return p.year === year && p.month === month && p.day === day && p.hour === hour && p.minute === minute;
  });
  if (matches.length !== 1) throw new Error(matches.length ? 'Ora este ambiguă la schimbarea orei de vară. Alegeți altă oră.' : 'Ora nu există în acest fus orar. Alegeți altă oră.');
  return new Date(matches[0]).toISOString();
}
